import script from "./ui-input-withIcon.vue?vue&type=script&setup=true&lang=ts"
export * from "./ui-input-withIcon.vue?vue&type=script&setup=true&lang=ts"

import "./ui-input-withIcon.vue?vue&type=style&index=0&id=24a5b5a6&lang=less"

const __exports__ = script;

export default __exports__